export default __webpack_public_path__ + "static/media/carousel-smartpoint.787f6ca6.jpg";